import React, { createContext, useContext, useState, useEffect } from 'react';

const BotContext = createContext();

export const useBot = () => {
  const context = useContext(BotContext);
  if (!context) {
    throw new Error('useBot must be used within a BotProvider');
  }
  return context;
};

export const BotProvider = ({ children }) => {
  const [selectedBotId, setSelectedBotId] = useState(() => {
    // Load from localStorage if available
    const saved = localStorage.getItem('selectedBotId');
    return saved || null;
  });
  const [bots, setBots] = useState([]);
  const [isLoadingBots, setIsLoadingBots] = useState(false);

  // Save to localStorage whenever selectedBotId changes
  useEffect(() => {
    if (selectedBotId) {
      localStorage.setItem('selectedBotId', selectedBotId);
    } else {
      localStorage.removeItem('selectedBotId');
    }
  }, [selectedBotId]);

  // Auto-select first bot if none selected and bots are loaded
  useEffect(() => {
    if (!selectedBotId && bots.length > 0) {
      setSelectedBotId(bots[0].bot_id);
    }
  }, [bots, selectedBotId]);

  return (
    <BotContext.Provider
      value={{
        selectedBotId,
        setSelectedBotId,
        bots,
        setBots,
        isLoadingBots,
        setIsLoadingBots
      }}
    >
      {children}
    </BotContext.Provider>
  );
};

